import React, { useState } from 'react';
import { TableContainer, FormControlLabel, TextField, Paper, Card, Switch, CircularProgress } from '@mui/material';
import SoftButton from "components/SoftButton";
import SoftInput from 'components/SoftInput';
import SoftBox from 'components/SoftBox';
import { useEffect } from 'react';
import { baseURL } from 'utils/api';
import toast from 'react-hot-toast';
import SoftTypography from 'components/SoftTypography';
import { useSelector } from 'react-redux';

const HappyHours = ({ id }) => {

  const userTheme = useSelector((state) => state.commonSlice.theme);
  const [hours, setHours] = useState([
    { day: 'Sunday', openingHours: '', closingHours: '', isSplit: false, isOpen: false, isClosed: false, isSplitHours: false, secondOpeningHours: '', secondClosingHours: '' },
    { day: 'Monday', openingHours: '', closingHours: '', isSplit: false, isOpen: false, isClosed: false, isSplitHours: false, secondOpeningHours: '', secondClosingHours: '' },
    { day: 'Tuesday', openingHours: '', closingHours: '', isSplit: false, isOpen: false, isClosed: false, isSplitHours: false, secondOpeningHours: '', secondClosingHours: '' },
    { day: 'Wednesday', openingHours: '', closingHours: '', isSplit: false, isOpen: false, isClosed: false, isSplitHours: false, secondOpeningHours: '', secondClosingHours: '' },
    { day: 'Thursday', openingHours: '', closingHours: '', isSplit: false, isOpen: false, isClosed: false, isSplitHours: false, secondOpeningHours: '', secondClosingHours: '' },
    { day: 'Friday', openingHours: '', closingHours: '', isSplit: false, isOpen: false, isClosed: false, isSplitHours: false, secondOpeningHours: '', secondClosingHours: '' },
    { day: 'Saturday', openingHours: '', closingHours: '', isSplit: false, isOpen: false, isClosed: false, isSplitHours: false, secondOpeningHours: '', secondClosingHours: '' }
  ]);

  const [image, setImage] = useState(null);
  const [imageURL, setImageURL] = useState('');
  const [madeChanges, setMadeChanges] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    setMadeChanges(true);
    const file = e.target.files[0];
    if (file.size > 10000000) {
      toast.error('File size should be less than 10MB');
      return;
    }
    setImage(file);
    setImageURL(URL.createObjectURL(file));
  }


  useEffect(() => {
    fetch(`${baseURL}get/happyHours/${id}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    }).then((res) => res.json())
      .then((data) => {
        console.log(data, 'data 124');
        if (data.success) {
          setHours(data?.data?.happyHoursTiming);
          setImageURL(`${data?.data?.businessHappyHoursImage}`);
        }
        else {
          // toast.error(data.message);
        }
      }).catch(err => {
        toast.error(err.message || 'Something went wrong');
      }
      );

  }, []);


  const handleCheckboxChange = (i) => {
    setMadeChanges(true);
    if (hours[i].openingHours == '' && hours[i].closingHours == '') {
      setHours([...hours], hours[i].openingHours = '09:00 AM', hours[i].closingHours = '05:00 PM', hours[i].isOpen = true)
    } else {

      setHours([...hours], hours[i].openingHours = '', hours[i].isOpen = false, hours[i].isSplit = false, hours[i].closingHours = '', hours[i].secondOpeningHours = '', hours[i].secondClosingHours = '');
    }
  };

  const convertToAmPm = (time) => {
    let [hours, minutes] = time.split(':'); // Properly split hours and minutes
    hours = parseInt(hours, 10);
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert 0 to 12 for 12 AM
    const formattedHours = hours < 10 ? `0${hours}` : `${hours}`;
    const formattedMinutes = minutes.padStart(2, '0'); // Ensure minutes have leading zero
    return `${formattedHours}:${formattedMinutes} ${ampm}`;
  };


  const convertAmPmTo24 = (time) => {
    const [timePart, meridiem] = time.split(' '); // Split time and AM/PM 
    let [hours, minutes] = timePart.split(':'); // Properly split hours and minutes 
    hours = parseInt(hours, 10);
    minutes = parseInt(minutes, 10); // Ensure minutes is an integer

    if (meridiem === 'PM' && hours < 12) hours += 12; // Convert 12-hour time to 24-hour time
    if (meridiem === 'AM' && hours === 12) hours = 0; // Convert 12 AM to 0 hours

    const formattedHours = hours < 10 ? `0${hours}` : `${hours}`;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`; // Add leading zero if needed

    return `${formattedHours}:${formattedMinutes}`;
  };

  const handleTimeChange = (i, type, value) => {
    setMadeChanges(true);
    const convertedValue = convertToAmPm(value);
    if (type == 'from') {
      setHours([...hours], hours[i].openingHours = convertedValue);
    } else {
      setHours([...hours], hours[i].closingHours = convertedValue);
    }
  };

  const handleSplitHoursTimeChange = (i, type, value) => {
    setMadeChanges(true);
    const convertedValue = convertToAmPm(value);
    if (type == 'from') {
      setHours([...hours], hours[i].secondOpeningHours = convertedValue);
    } else {
      setHours([...hours], hours[i].secondClosingHours = convertedValue);
    }
  };


  const handleChangeSplitHours = (i) => {
    setMadeChanges(true);
    if (hours[i].secondOpeningHours == '' && hours[i].secondClosingHours == '') {
      setHours([...hours], hours[i].secondOpeningHours = '09:00 AM', hours[i].secondClosingHours = '05:00 PM', hours[i].isSplit = true)
    } else {
      setHours([...hours], hours[i].secondOpeningHours = '', hours[i].secondClosingHours = '', hours[i].isSplit = false);
    }
  }

  const handleUpdate = (e) => {
    e.preventDefault();

    // if (!image) {
    //   toast.error('Please upload an image');
    //   return;
    // }
    setLoading(true);


    const formData = new FormData();
    formData.append('happyHoursTiming', JSON.stringify(hours));
    image && formData.append('businessHappyHoursImage', image);
    formData.append('businessId', id);

    fetch(`${baseURL}createAndUpdate/happyHours`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
        // Do NOT set 'Content-Type' when using FormData
      },
      body: formData
    })
      .then(res => res.json())
      .then(data => {
        setLoading(false);
        console.log(data, 'data date');
        if (data.success) {
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
      })
      .catch(err => {
        setLoading(false);
        console.log(err, 'error');
        toast.error(err.message || 'Something went wrong');
      });
  };





  return (

    <>

      {/* File Upload Section */}
      <SoftTypography
        variant="h6"
        sx={{ fontWeight: "bold", color: "info", mt: 3 }}
      >
        Happy Hour Image
      </SoftTypography>
      <Card
        className="glassmorphism-card"
        sx={{
          border: "1px dashed #ccc",
          borderRadius: 2,
          p: 1,
          textAlign: "center",
          mt: 2
        }}
      >

        {imageURL
          ? <SoftBox
            sx={{
              border: "1px solid #ccc",
              borderRadius: 2,
              width: "100%",
              height: 300,
            }}
            mt={4} mb={2}>
            <img
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              src={imageURL}
              alt="image"
              onError={(e) => { e.target.src = "https://placehold.co/500x500?text=Image Not Found"; }}
            />

          </SoftBox>
          : 'No file selected'}
        <SoftTypography
          variant="caption"
          sx={{
            mb: 2
          }}
        >
          Upload an image for your happy hour
        </SoftTypography>
        <input
          id="pdfUpload"
          type="file"
          // accept="application/pdf"
          onChange={handleFileChange}
          style={{ display: "none" }}

        />
        <label htmlFor="pdfUpload">
          <SoftButton
            variant="outlined"
            component="span"
            sx={{

              textTransform: "none",
              color: userTheme == 'dark' ? "#ffffff" : "#141414",
              border: userTheme == 'dark' ? "1px solid #ffffff" : "1px solid #141414",
            }}
          >
            Select File
          </SoftButton>
        </label>


      </Card>
      <SoftBox className="glassmorphism-card" component={Paper} sx={{ marginTop: 2 }}>


        <SoftBox>
          {hours && hours.length > 0 && hours.map((elm, i) => (
            <>
              <SoftBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: 2,
                  borderBottom: "1px solid #f0f0f0",
                  width: 800
                }}
                gap={2}
              >
                <SoftTypography
                  variant="caption"
                  sx={{ width: 160, fontSize: '14px' }}
                >{elm?.day.charAt(0).toUpperCase() + elm?.day.slice(1)}</SoftTypography>
                <SoftBox>

                  <SoftBox
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "column",
                    }}
                  >

                    <SoftBox
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 260
                      }}
                    >
                      <SoftBox mr={2}  >
                        <SoftInput
                          label="From"
                          type="time"
                          disabled={elm?.closingHours == '' && elm?.openingHours == ''}
                          value={convertAmPmTo24(elm?.openingHours)}
                          onChange={(e) => handleTimeChange(i, 'from', e.target.value)}
                          inputProps={{ step: 300 }} // 5 minutes
                          InputLabelProps={{ shrink: true }}
                        />

                      </SoftBox>
                      <SoftBox>
                        <SoftInput
                          label="To"
                          type="time"
                          disabled={elm?.closingHours == '' && elm?.openingHours == ''}
                          value={convertAmPmTo24(elm?.closingHours)}
                          onChange={(e) => handleTimeChange(i, 'to', e.target.value)}
                          inputProps={{ step: 300 }}
                          InputLabelProps={{ shrink: true }}
                        />
                      </SoftBox>

                    </SoftBox>



                  </SoftBox>

                  {
                    elm?.secondOpeningHours != '' && elm?.secondClosingHours != '' && (
                      <SoftBox
                        mt={1}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: 260
                        }}
                      >
                        <SoftBox mr={2}  >
                          <SoftInput
                            label="From"
                            type="time"
                            value={convertAmPmTo24(elm?.secondOpeningHours)}
                            onChange={(e) => handleSplitHoursTimeChange(i, 'from', e.target.value)}
                            inputProps={{ step: 300 }} // 5 minutes
                            InputLabelProps={{ shrink: true }}
                          />
                        </SoftBox>
                        <SoftBox

                        >
                          <SoftInput
                            label="To"
                            type="time"
                            value={convertAmPmTo24(elm?.secondClosingHours)}
                            onChange={(e) => handleSplitHoursTimeChange(i, 'to', e.target.value)}
                            inputProps={{ step: 300 }}
                            InputLabelProps={{ shrink: true }}
                          />
                        </SoftBox>

                      </SoftBox>
                    )
                  }
                </SoftBox>

                <SoftBox
                  sx={{
                    width: 160
                  }}
                >


                  <FormControlLabel
                    control={
                      <Switch
                        // checked={(elm?.closingHours == '') && (elm?.openingHours == '')}
                        checked={elm.isOpen}
                        onChange={() => handleCheckboxChange(i)}
                      />
                    }
                    label={elm.isOpen ? 'Open' : 'Closed'}
                    sx={{
                      '& .MuiFormControlLabel-label': {
                        color: userTheme === 'dark' ? '#ffffff !important' : '#000000 !important', // Dynamic label color
                      },
                    }}
                  />
                </SoftBox>
                <SoftBox
                  sx={{
                    width: 160
                  }}
                >
                  <FormControlLabel
                    control={
                      <Switch
                        disabled={!elm?.isOpen}
                        // checked={elm?.secondOpeningHours != '' && elm?.secondClosingHours}
                        checked={elm.isSplit}
                        onChange={() => handleChangeSplitHours(i)}
                      />
                    }
                    label="Split Hours"
                    sx={{
                      '& .MuiFormControlLabel-label': {
                        color: userTheme === 'dark' ? '#ffffff !important' : '#000000 !important', // Dynamic label color
                      },
                    }}
                  />
                </SoftBox>
              </SoftBox>

            </>
          ))}
        </SoftBox>

        <SoftBox
          m={2}
        >
          <SoftButton variant="gradient"
            sx={{ marginTop: 2, marginRight: 2 }}
            onClick={handleUpdate}
            color={madeChanges ? "info" : "light"}
            disabled={!madeChanges}
            fullWidth
          >
            {
              loading ? <CircularProgress size={24} /> : 'Save Changes'
            }
          </SoftButton>

        </SoftBox>
      </SoftBox >
    </>
  );
};

export default HappyHours;
